import React, { ReactElement } from 'react';
import { ConfirmModal, Tooltip } from 'slovlex-idsk-react-components';
import { Button, LoaderButton } from 'idsk-react-components';
import deleteIcon from '../../../../../assets/images/icon-bin-red.svg';
import deleteTooltipIcon from '../../../../../assets/images/icon-bin-tooltip.svg';
import Uuid from '../../../../model/Uuid';
import { useClientStatusContext } from '../../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import './deleteSprievodnyDokumentButton.scss';
import { ClientStatus } from '../../../../model/ClientStatus';

interface Props {
  sprievodnyDokumentUuid: Uuid;
  deleteDokument: (dokumentUuid: Uuid) => void;
  deleteDokumentStatus?: ClientStatus;
  useTooltipIcon?: boolean;
}

export default function DeleteSprievodnyDokumentButton({
  sprievodnyDokumentUuid,
  deleteDokument,
  deleteDokumentStatus,
  useTooltipIcon,
}: Props): ReactElement {
  const { clearMessages } = useSuccessMessageContext();
  const { clearStatus } = useClientStatusContext();

  const clearStatusAndMessages = (): void => {
    clearStatus();
    clearMessages();
  };

  return sprievodnyDokumentUuid && (
    <ConfirmModal
      question="Naozaj si prajete odstrániť zvolený sprievodný dokument?"
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="negative"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={useTooltipIcon ? (
        <Tooltip tooltipText="Zmazať dokument" className="sprievodny-dokument-action-tooltip">
          <LoaderButton
            loading={deleteDokumentStatus?.loading}
            className="sprievodny-dokument-button delete-sprievodny-dokument-button"
            customIconBefore={deleteTooltipIcon}
            size="small"
            onClick={clearStatusAndMessages}
            buttonStyle="link"
            disableOutsideClickWhileLoading
          />
        </Tooltip>
      ) : (
        <LoaderButton
          loading={deleteDokumentStatus?.loading}
          className="sprievodny-dokument-button delete-sprievodny-dokument-button"
          customIconBefore={deleteIcon}
          size="small"
          onClick={clearStatusAndMessages}
          buttonStyle="link"
          disableOutsideClickWhileLoading
        >Zmazať
        </LoaderButton>
      )}
      doAfterConfirm={() => deleteDokument(sprievodnyDokumentUuid)}
    />
  );
}
